import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CoreConfigService } from '@core/services/config.service';
import { ToastService } from 'app/components/toasts/toasts.service';
import { DataService } from 'app/services/data.service';
import { AuthenticationService } from 'app/auth/service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from 'app/common/login/login.component';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy, AfterViewInit {


  public servicesPrice = {
    SIX_MONTH_PACK: 299.94,
    YEARLY_PACK: 479.95,
    ENTERPRISE_PACK: 1800
  }

  private isUser: any = null;
  public codeError: boolean = false;

  public promoid: string = '';
  public coreConfig: any;
  public isLoading: boolean = false;
  private _unsubscribeAll: Subject<any>;
  public isAcceptPrivacyPolicy: FormControl = new FormControl(false);
  public passwordTextType: boolean;
  public loading: boolean = false;
  public submitted = false;
  public OTPInfo: OtpData = null;
  public errorMessage = null;
  public discount: number = 0;
  public verificationCode: FormControl = new FormControl(null, [Validators.required, Validators.maxLength(6)]);
  public accountForm: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, Validators.required),
    fullName: new FormControl(null, Validators.required),
    hearAboutUs: new FormControl(null, Validators.required),
    isNewsletter: new FormControl(true),
    product: new FormControl(null, Validators.required),
    defaultProduct: new FormControl('CRYPTO', Validators.required),
    referalCode: new FormControl(null),
    walletAddress: new FormControl(null),
    number: new FormControl(null, [Validators.required, Validators.maxLength(18)]),
    expMonth: new FormControl(null, Validators.required),
    expYear: new FormControl(null, Validators.required),
    cvc: new FormControl(null, Validators.required),
  });

  constructor(
    private _coreConfigService: CoreConfigService,
    private _toastrService: ToastService,
    private _dataService: DataService,
    private _authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private _router: Router
    ) {
      this._unsubscribeAll = new Subject();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  ngOnInit(): void {
    this.accountForm.get('referalCode').valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((code) => {
      this.codeError = false;
      if(code){
        this._dataService.checkPaymentDiscount(code).toPromise().then((res) => {
          if(res.success){
            this.promoid = res.data.id;
            this.discount = res.data.coupon.percent_off;
            this.servicesPrice.SIX_MONTH_PACK = parseFloat((this.servicesPrice.SIX_MONTH_PACK - ((this.servicesPrice.SIX_MONTH_PACK / 100) * this.discount)).toFixed(2));
            this.servicesPrice.YEARLY_PACK = parseFloat((this.servicesPrice.YEARLY_PACK - ((this.servicesPrice.YEARLY_PACK / 100) * this.discount)).toFixed(2));
            this.servicesPrice.ENTERPRISE_PACK = parseFloat((this.servicesPrice.ENTERPRISE_PACK - ((this.servicesPrice.ENTERPRISE_PACK / 100) * this.discount)).toFixed(2));
            if(this.discount == 100){
              this.disableCardDetails();
            } else {
              this.enableCardDetails();
            }
          }}).catch((ex) => {
            this.discount = 0;
            this.promoid = '';
            this.setDefaultPrice();
            this.codeError = true;
        })
      } else {
        this.discount = 0;
        this.promoid = '';
        this.setDefaultPrice();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 400);
    let user = JSON.parse(localStorage.getItem('saga4562asda456ads'));
    if(user){
      this.isUser = user;
    }
  }

  // convenience getter for easy access to form fields
  get af() {
    return this.accountForm.controls;
  }

  onAccountSubmit(){
    this.isLoading = true;
    this.errorMessage = null;
    if(this.accountForm.valid){
      if(this.discount == 100){
        this.createUser().then((result: boolean) => {
          if(result){
            // with update subscription
            let product = this.accountForm.get('product').value;
            this._dataService.createSubscription(product, this.promoid).toPromise().then((result: any) =>{
              if(result.code == 1001){
                this._dataService.refreshUserToken().toPromise().then((result:any) =>{
                  this._authenticationService.setUser(result.data);
                  let defaultProduct = this.accountForm.get('defaultProduct').value;
                  localStorage.removeItem('saga4562asda456ads')
                  if(defaultProduct == 'STOCK'){
                    this._router.navigateByUrl('/stock');
                  } else if(defaultProduct == 'CRYPTO') {
                    this._router.navigateByUrl('/crypto');
                  } else {
                    // this._router.navigateByUrl('/nft');
                    this._router.navigateByUrl('/crypto');
                  }
                }).catch((err) =>{
                  this.errorMessage = err;
                  this.isLoading = false;
                });
              }
            }).catch((err)=>{
              this.errorMessage = err;
              this.isLoading = false;
            });
          }
        });
      } else {
        if(this.isUser){
          this.cardSubmit();
        } else {
          this.createUser().then((result: boolean) => {
            if(result){
              this.cardSubmit();
            }
          });
        }
      }
    } else {
      this.submitted = true;
      this.isLoading = false;
      this.errorMessage = null;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  /**
 * Toggle password
 */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  generateOTP(){
    let email = this.accountForm.get('email').value;
    return this._dataService.generateOTP(email).toPromise();
  }

  createUser(): Promise<boolean>{
    this.isLoading = true;
    this.errorMessage = null;
    let userInfo = this.accountForm.value;
    return new Promise((resolve) => {
      this._dataService.createUser(userInfo).toPromise().then((result: any) =>{
        if(result.code == 1001){
          localStorage.setItem('saga4562asda456ads', JSON.stringify(result));
          this.isUser = result;
          this._authenticationService.setUser(result.data);
          resolve(true);
        }
      }).catch((err) =>{
        resolve(false);
        this.errorMessage = err;
        this.isLoading = false;
      })
    });
  }

  resendOTP(){
    this.isLoading = false;
    this.errorMessage = null;
    this.generateOTP().then((result: any) =>{
      this.OTPInfo = result.data;
      this._toastrService.show('We send OTP on your email', {
        delay: 2000,
        classname: 'bg-primary text-light',
        autohide: true
      })
    })
  }

  /* submit card details */
  cardSubmit(){
    this.isLoading = true;
    this.errorMessage = null;
    let info = {
      number: this.accountForm.value.number,
      expMonth: this.accountForm.value.expMonth,
      expYear: this.accountForm.value.expYear,
      cvc: this.accountForm.value.cvc,
    };

    info.number = info.number.replace(/\s/g, '');
    this._dataService.createUpdateCard(info).toPromise().then((result: any) =>{
      if(result.code == 1001){
        let product = this.accountForm.get('product').value;
        this._dataService.createSubscription(product, this.promoid).toPromise().then((result: any) =>{
          if(result.code == 1001){
            this._dataService.refreshUserToken().toPromise().then((result:any) =>{
              this._authenticationService.setUser(result.data);
              let defaultProduct = this.accountForm.get('defaultProduct').value;
              localStorage.removeItem('saga4562asda456ads')
              if(defaultProduct == 'STOCK'){
                this._router.navigateByUrl('/stock');
              } else if(defaultProduct == 'CRYPTO') {
                this._router.navigateByUrl('/crypto');
              } else {
                // this._router.navigateByUrl('/nft');
                this._router.navigateByUrl('/crypto');
              }
            }).catch((err) =>{
              this.errorMessage = err;
              this.isLoading = false;
            });
          }
        }).catch((err)=>{
          this.errorMessage = err;
          this.isLoading = false;
        });
      }
    }).catch((err) =>{
      this.errorMessage = err;
      this.isLoading = false;
    });
  }

  gotoLogin(){
    this.modalService.open(LoginComponent, {
      size: 'sm',
      centered: true
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /* open privacy popup */
  openPrivacyModal(modal){
    this.modalService.open(modal,{
      size: 'lg',
      scrollable: true,
    });
  }

  acceptPolicy(status){
    status ? this.isAcceptPrivacyPolicy.setValue(true) : this.isAcceptPrivacyPolicy.setValue(false);
    this.modalService.dismissAll();
  }

  setDefaultPrice(){
    this.servicesPrice = {
      SIX_MONTH_PACK: 299.94,
      YEARLY_PACK: 479.95,
      ENTERPRISE_PACK: 1800
    }
  }

  private disableCardDetails(){
    let arr = ['number', 'expMonth', 'expYear', 'cvc'];
    arr.forEach(element => {
      this.accountForm.get(element).clearValidators();
      this.accountForm.get(element).updateValueAndValidity();
    });
  };

  private enableCardDetails(){
    let arr = ['number', 'expMonth', 'expYear', 'cvc'];
    arr.forEach(element => {
      this.accountForm.get(element).setValidators(Validators.required);
      this.accountForm.get(element).updateValueAndValidity();
    });
  };

}

export interface OtpData {
  encryptedData: string;
  iv: string;
}

export interface UserInfo {
  token: string;
  userId: string;
}